export default __webpack_public_path__ + "static/media/lc-icon.b6bec152.webp";